import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAdminAuth } from '../context/AdminAuthContext';

export default function ProtectedRoute({ children }) {
  const { session, isAdmin, loading, isConfigured } = useAdminAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div
        className="min-h-screen bg-slate-950 flex flex-col items-center justify-center text-white"
        style={{ minHeight: '100vh', backgroundColor: '#020617', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', color: '#ffffff' }}
      >
        <div
          className="w-12 h-12 border-4 border-[#9BB7A3]/30 border-t-[#9BB7A3] rounded-full animate-spin mb-4"
          style={{ width: '48px', height: '48px', borderRadius: '50%', border: '4px solid rgba(155, 183, 163, 0.3)', borderTopColor: '#9BB7A3', animation: 'spin 1s linear infinite', marginBottom: '16px' }}
        ></div>
        <p className="text-slate-400 text-sm font-medium tracking-wide" style={{ color: '#94a3b8', fontSize: '14px' }}>
          Authenticating Admin Session...
        </p>
      </div>
    );
  }

  // Strictly require Supabase admin session
  if (!isConfigured || !session || !isAdmin) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  return children;
}
